(function(register){
    if (document.readyState !== 'loading') {
        register();
    } else {
        document.addEventListener('DOMContentLoaded', register, {
            once: true,
            passive: true,
        });
    }
})(function() {
    if (customElements.get('base-countdown') === undefined) {
        const template = document.createElement('template');
        template.innerHTML = `
        <style>
        :host {
            display: block;
        }
        time {
            display: block;
        }
        [part="units"] {
            display: flex;
            align-items: stretch;
        }
        [part="unit-wrap"] {
            flex: 1 0 25%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
        </style>
        <time>
            <span part="units">
                <span part="unit-wrap" data-unit="days">
                    <span part="value">0</span>
                    <span part="unit"><slot name="daysLabel">Days</slot></span>
                </span>
                <span part="unit-wrap" data-unit="hours">
                    <span part="value">0</span>
                    <span part="unit"><slot name="hoursLabel">Hours</slot></span>
                </span>
                <span part="unit-wrap" data-unit="minutes">
                    <span part="value">0</span>
                    <span part="unit"><slot name="minutesLabel">Minutes</slot></span>
                </span>
                <span part="unit-wrap" data-unit="seconds">
                    <span part="value">0</span>
                    <span part="unit"><slot name="secondsLabel">Seconds</slot></span>
                </span>
            </span>
        </time>
        `;
        customElements.define('base-countdown', class extends HTMLElement {
            get dateTime() {
                return new Date(this.getAttribute('datetime'));
            }

            set dateTime(datestring) {
                this.setAttribute('datetime', datestring);
                this.update();
            }

            constructor() {
                super();
                this.attachShadow({mode: "open"}).appendChild(template.content.cloneNode(true));
                this.update();
            }

            update() {
                const dateTime = this.dateTime;
                const now = new Date();
                let diffInSeconds = (dateTime - now) / 1000;
                const done = diffInSeconds <= 0;
                let days = Math.max(0, Math.floor(diffInSeconds / 86400));
                diffInSeconds -= days * 86400;
                let hours = Math.max(0, Math.floor(diffInSeconds / 3600));
                diffInSeconds -= hours * 3600;
                let minutes = Math.max(0, Math.floor(diffInSeconds / 60));
                diffInSeconds -= minutes * 60;
                let seconds = Math.max(0, Math.floor(diffInSeconds));
                this.dispatchEvent(new CustomEvent('updating', {
                    detail: {
                        diffInSeconds,
                        days,
                        hours,
                        minutes,
                        seconds,
                    }
                }));
                this.shadowRoot.querySelector('time').dateTime = this.getAttribute('datetime');
                this.shadowRoot.querySelector('[data-unit="days"] [part="value"]').innerHTML = `${days}`;
                this.shadowRoot.querySelector('[data-unit="hours"] [part="value"]').innerHTML = `${hours}`;
                this.shadowRoot.querySelector('[data-unit="minutes"] [part="value"]').innerHTML = `${minutes}`;
                this.shadowRoot.querySelector('[data-unit="seconds"] [part="value"]').innerHTML = `${seconds}`;
                this.dispatchEvent(new CustomEvent('updated'));
                if (done) {
                    clearInterval(this.interval);
                    this.dispatchEvent(new CustomEvent('deadline'));
                }
            }

            connectedCallback() {
                this.interval = setInterval(this.update.bind(this), 1000)
            }

            disconnectedCallback() {
                clearInterval(this.interval);
            }
        });
    }
});

